import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

const TestimonialsCarousel = {
  init() {
    const section = document.querySelector('.customer-testimonials');
    if (!section || window.innerWidth >= 1024) return;

    const container = section.querySelector('.swiper');

    new Swiper(container, {
        modules: [Pagination],
        loop: true,
        slidesPerView: 1.1,
        spaceBetween: 16,
        pagination: {
            el: '.customer-testimonials__pagination',
            clickable: true,
        }
    });
  }
};

export default TestimonialsCarousel;
